import { render, staticRenderFns } from "./hpText2.vue?vue&type=template&id=734e01bc&scoped=true&"
import script from "./hpText2.vue?vue&type=script&lang=js&"
export * from "./hpText2.vue?vue&type=script&lang=js&"
import style0 from "./hpText2.vue?vue&type=style&index=0&id=734e01bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e01bc",
  null
  
)

export default component.exports